import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { SignatureFieldWUT } from '../../../ui/signature-field/signature-field-wut';
export function SignatureWUT(props) {
    const { fieldType = FIELD_TYPES.SIGNATURE } = props;
    return /*#__PURE__*/ React.createElement(SignatureFieldWUT, {
        ...props,
        fieldType: fieldType
    });
}

//# sourceMappingURL=signature-wut.js.map